<template>
  <!-- <div class="flex-align">
    <div class="file-lock flex-center">
      <div class="file-lock__icon">
        <img :src="require('@/assets/images/lock.png')" alt="" />
      </div>
      <div class="file-lock__content">
        <span>{{ title }}</span>
      </div>
    </div>
  </div> -->
  <div class="file-lock">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'ApplyContentLock',

  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.file-lock {
  color: $third-text-color;
  font-size: 14px;
}
</style>
